<div class="addWishlist" (click)="onClick()">
    <mat-icon *ngIf="!isInWishlist" class="add">add_2</mat-icon>
    <mat-icon *ngIf="isInWishlist" class="remove">remove</mat-icon>
</div>